// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.logo[data-v-4e2f10d4] {\n  height: 50px;\n  background: #1890ff;\n  margin: 16px;\n  color: #fff;\n  font-size: 16px;\n  line-height: 50px;\n}\n.mc-left-sider[data-v-4e2f10d4] {\n  /* position: fixed; */\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  background-color: #fff;\n}\n.mc-left-fix-top[data-v-4e2f10d4] {\n  top: 0;\n}\n.ant-menu-inline[data-v-4e2f10d4] {\n  border: none;\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
